import { Box, Typography, LinearProgress } from "@mui/material";


const StatBar = ({ 
  icon, 
  label, 
  count, 
  percent, 
  targetPercent,
  color="primary", 
  onClick 
}) => {
  return (
      <Box
        onClick={onClick}
        sx={{
          cursor: onClick ? "pointer" : "default",
          "&:hover": { transform: "scale(1.002)" },
        }}
      >
        <Box 
          display="flex" 
          justifyContent="space-between" 
          mb={0.5}
        >
          <Box display="flex" alignItems="center" gap={1}>
            {icon}
            <Typography variant="body2">
              {label}
            </Typography>
          </Box>
          <Typography variant="caption">
            {count} ({percent}%)
          </Typography>
        </Box>

        {/* Progress wrapper */}
        <Box sx={{ position: "relative", pb: 3 }}>
          <LinearProgress
            variant="determinate"
            value={percent}
            sx={{
              height: 8,
              borderRadius: 5,
              backgroundColor: "neutral.main",
              "& .MuiLinearProgress-bar": {
                backgroundColor: color,
              },
            }}
          />

          {/* Target marker */}
          {targetPercent && (
            <>
              <Box
                sx={{
                  position: "absolute",
                  left: `${targetPercent}%`,
                  top: -4,
                  height: 16,
                  width: 2,
                  borderRadius: 1,
                  backgroundColor: "primary.main",
                  transform: "translateX(-50%)",
                }}
              />
              
              <Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  left: `${targetPercent}%`,
                  top: 12,
                  transform: "translateX(-50%)",
                  whiteSpace: "nowrap",
                }}
              >
                {targetPercent}%
              </Typography>
            </>
          )}
        </Box>
      </Box>
  );
};

export default StatBar;
